<template>
  <div class="isWeb">
    <div class="top">
      <!-- 로고 클릭 시 메인 페이지 이동 -->
      <router-link :to="{name: 'main'}" class="logoGroup"></router-link>
    </div>
    <div class="contents">
      <!-- poster와 game 데이터 있을 때 포스터 이미지 표시 -->
      <img v-if="!temp && game.game_id" class="bg" :src="poster" alt="" />

      <!-- 경기 일정 표시 박스 -->
      <div v-if="!temp && game.game_id" class="matchBox">
        <div class="bannerTitle">
          <!-- 리그에 따라 배너 이미지 변경 -->
          <img
            v-if="game.league_name !== 'kleague'"
            src="@/assets/img/web/ico_facup.png"
            width="80"
            alt="banner_img"
          />
          <img v-else src="@/assets/img/web/kleague_ico.png" alt="banner_img" width="80" />
        </div>
        <div>
          <div class="game">
            <!-- 홈팀 엠블럼 -->
            <div class="emblem"><img :src="getEmblem(game.home_team)" alt="" /></div>
            <div class="vs">
              <p class="title">VS</p>
              <p>{{ game.type }}</p>
            </div>
            <!-- 어웨이팀 엠블럼 -->
            <div class="emblem"><img :src="getEmblem(game.away_team)" alt="" /></div>
          </div>

          <div class="info">
            <div class="stadium">
              <!-- 경기 날짜와 요일, 경기장명 -->
              {{ game.year }}년 {{ game.month }}월 {{ game.day }}일
              ({{ game.game_yoil }}) @{{ game.field_name }}
            </div>
            <div class="date">{{ game.game_time }}</div>
          </div>
        </div>
        <div class="btns">
          <!-- 홈경기면 온라인 예매 버튼 클릭 시 ticketing 호출 -->
          <a
            v-if="game.type === '홈'"
            type="button"
            @click="callTicketing('ticketing', game.product_code)"
            class="btn"
          >
            온라인 예매하기
          </a>
          <!-- 원정경기면 외부 예매 사이트 링크 -->
          <a
            v-else
            href="https://www.kleague.com/schedule.do?leagueId=2"
            class="slideLink"
            target="_blank"
          >
            온라인 예매하기
          </a>
        </div>
      </div>

      <!-- temp가 true일 경우 임시 배너 -->
      <div v-if="temp" class="matchBox">
        <!-- 버튼 사용 시 레이아웃 -->
        <!--
        <img alt="" src="@/assets/img/banner/dragons.jpg" />
        <div class="btns">
          <router-link to="/ticket/seasonInfo" class="btn">구매하기</router-link>
        </div>
        -->

        <!-- 버튼 + 이미지 링크 레이아웃 -->
        <router-link to="/fans/notice/detail/10766" class="block">
          <img src="@/assets/img/banner/dragons.png" alt="포스터"/>
        </router-link>
        <p class="btns">
          <router-link to="/fans/notice/detail/10766">
            <a href="#" class="btn">경기일정 확인</a>
          </router-link>
        </p>

        <!-- 버튼 미사용, 이미지 링크 레이아웃 -->
        <!--
        <a href="/fans/notice/detail/10756">
          <img src="@/assets/img/banner/dragons.jpg" alt="포스터"/>
        </a>
        -->
      </div>
    </div>

    <!-- 배너 슬라이더는 현재 주석 처리 상태 -->
    <!--
    <div class="footer">
      <swiper ref="bannerSwiper" class="banner-swiper" :options="bannerSwiperOption">
        <swiper-slide
          v-for="(item, index) in banner" :key="index" class="slide">
          <img :src="item.slide_img" alt="">
          <div class="txtCont">
            <div class="inner">
              <p class="content">{{ item.content }}</p>
              <p class="title">{{ item.subject }}</p>
            </div>
          </div>

          <div class="txtBox">
            <div class="txt">
              <p>{{item.desc}}</p>
              <p class="title">{{item.title}}</p>
            </div>
            <div class="percent">
              {{item.pointText}}<span>%</span>
            </div>
          </div>

        </swiper-slide>
      </swiper>
    </div>
    -->
  </div>
</template>

<script>
import 'swiper/css/swiper.css';
import { checkBrowser, getEmblem } from '@/lib';
import { leagueName } from '@/lib/match';
import { ticketingFunc } from '@/lib/ticketingModule';
import dayjs from 'dayjs';

export default {
  name: 'WebView',
  computed: {
    dayjs() {
      return dayjs;
    },
  },
  components: {
    // Swiper, SwiperSlide 주석처리됨
  },
  mounted() {
    this.getMatch(); // 컴포넌트 마운트 시 최근 경기 정보 로드
    this.getBanner(); // 배너 데이터 로드
  },
  data() {
    return {
      game: {}, // 경기 정보
      poster: '', // 포스터 이미지 url
      banner: [], // 배너 리스트
      bannerSwiperOption: {
        slidesPerView: 1,
      },
      ticketing: {}, // 예매 상태 (현재 사용 안함)
      ticketingUrl: '', // 예매 url (현재 사용 안함)
      temp: true, // 임시 모드 플래그 (true일 때 임시 이미지만 표시)
    };
  },
  methods: {
    getEmblem,
    async getMatch() {
      // '/game' API로 경기 정보 조회
      const { data } = await this.$http.get('/game');
      const nextGame = data.data.next_game;
      if (data.success && nextGame.length > 0) {
        this.game = nextGame[0];

        // 홈팀 여부에 따라 경기 타입 결정
        if (this.game.home_team === 'K07') {
          this.game.type = '홈';
        } else {
          this.game.type = '어웨이';
        }

        // 리그 이름 표기
        this.game.league_name = leagueName(this.game.meet_name);

        // 날짜 문자열 분리
        const date = this.game.game_date.split('.');
        this.game.year = date[0];
        this.game.month = date[1];
        this.game.day = date[2];

        // 시간 문자열 HH:mm 형식으로 자르기
        this.game.game_time = this.game.game_time.substring(0, 5);

        // 포스터 이미지 데이터 요청
        let postData = await this.$http.get(`/game/poster?year=${this.game.year}&game_id=${this.game.game_id}`);
        postData = postData.data;
        if (postData.success && postData.data.poster) {
          this.poster = postData.data.poster;
          // 임시 포스터 예시:
          // this.poster = 'https://www.dragons.co.kr/resource/img/content/img_mascot2023_intro.png'
        }
      }
    },
    async getBanner() {
      // 배너 이미지 리스트 조회
      const { data } = await this.$http.get('/main/slide_side');
      if (data.success) {
        this.banner = data.data;
        // console.log('--->', this.banner);
        // this.banner[0].content = 'test content';
      }
    },
    async callTicketing(type, productCode) {
      // 예매 기능 호출 전 로그인 여부 확인
      if (!this.$store.state.login) {
        alert('로그인 후 이용 가능합니다.');
        await this.$router.push('/login');
        return false;
      }
      // 모듈로 분리된 예매 함수 호출
      await ticketingFunc({ http: this.$http }, type, productCode);
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-swiper {
  height: 135px;

  .slide {
    position: relative;

    .txtCont {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% - 80px);
      height: 100%;
      display: flex;
      padding-left: 40px;

      .inner {
        align-self: center;
        color: #999;

        .title {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
        }
      }
    }
  }
  img {
    width: 100%;
  }
}
.btns a {
  cursor: pointer;
}
</style>
